/**
 * This returns the cardinality of operator from the passed filterConfiguration
 * @param filterConfiguration
 * @param operator
 * @returns {any}
 */
export default (filterConfiguration, operator) => {
  operator = operator.startsWith('not-') ? operator.substr(4) : operator
  const operatorDetail = filterConfiguration.operators[operator]
  return operatorDetail.cardinality
}
